import { ElevatorStandardNumber } from "../ElevatorPanelNumber";
import { cn } from "@/core/helpers/cn";
import displayLgImg from "@/domains/estate/components/elevator/res/display-business-lg@2x.png";
import displayMdImg from "@/domains/estate/components/elevator/res/display-business@2x.png";

export function ElevatorStandardFloorDisplay({
  size,
  currentFloor,
}: {
  size: "sm" | "lg";
  currentFloor: number;
}) {
  return (
    <div
      className={cn(
        "relative",
        size === "sm" && "w-[168px] h-[72px]",
        size === "lg" && "w-[288px] h-[72px]",
      )}
    >
      <div>
        {size === "sm" && <img src={displayMdImg} alt="" className="object-contain" />}
        {size === "lg" && <img src={displayLgImg} alt="" className="object-contain" />}
      </div>

      <div className="absolute z-10 top-0 left-0 flex justify-center items-center tabular-nums w-full h-full">
        <div className="scale-125">
          <ElevatorStandardNumber value={currentFloor} isActive />
        </div>
      </div>
    </div>
  );
}
